export function formDataToObject(formData, exceptKeys = []) {
    const obj = {};
    for (let [key, value] of formData.entries()) {
        if (exceptKeys.includes(key)) {
            continue;
        }
        if (obj[key]) {
            // Handle multiple values (checkboxes, select multiple)
            if (Array.isArray(obj[key])) {
                obj[key].push(value);
            } else {
                obj[key] = [obj[key], value];
            }
        } else {
            obj[key] = value;
        }
    }
    return obj;
}

export function objectToFormData(obj) {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(v => formData.append(key, v));
        } else {
            formData.append(key, value);
        }
    });
    return formData;
}

export function loadFormDataToInputs(formData, formElement, options = {}) {
    const { exceptKeys = [], clearFirst = false } = options;

    // Clear all inputs first if requested, except those in exceptKeys
    if (clearFirst) {
        const inputs = formElement.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            if (exceptKeys.includes(input.name)) {
                return; // Skip clearing this input
            }

            if (input.type === 'checkbox' || input.type === 'radio') {
                input.checked = false;
            } else if (input.tagName.toLowerCase() === 'select') {
                input.selectedIndex = -1;
                // Clear all selected options for multi-select
                Array.from(input.options).forEach(option => option.selected = false);
            } else {
                input.value = '';
            }
        });
    }

    // Populate inputs with FormData values
    for (let [key, value] of formData.entries()) {
        const input = formElement.querySelector(`[name="${key}"]`);
        if (!input) continue;

        if (input.type === 'checkbox') {
            // For checkboxes, check if the value matches
            if (input.value === value || value === 'on' || value === true || value === '1') {
                input.checked = true;
            }
        } else if (input.type === 'radio') {
            // For radio buttons, check the one with matching value
            if (input.value === value) {
                input.checked = true;
            }
        } else if (input.tagName.toLowerCase() === 'select') {
            if (input.multiple) {
                // For multi-select, select all matching options
                Array.from(input.options).forEach(option => {
                    if (option.value === value) {
                        option.selected = true;
                    }
                });
            } else {
                input.value = value;
            }
        } else {
            // For text, email, password, textarea, etc.
            input.value = value;
        }
    }
}

export function loadObjectToInputs(obj, formElement, options = {}) {
    // Convert object to FormData and use the existing function
    const formData = objectToFormData(obj);
    loadFormDataToInputs(formData, formElement, options);
}
